/** @format */

import React, { useState, useEffect } from "react";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import Page from "../../components/Page";
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
  IconButton,
  Box,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Iconify from "../../components/Iconify";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import Scrollbar from "../../components/Scrollbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
// import NumberMoreMenu from "../number/NumberMoreMenu";
// import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
// import PhoneNumber from "src/dao/PhoneNumber";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import MessageTemplate from "src/dao/MessageTemplate";
import swal from "../../reusables/CustomSwal";
import Select from "react-select";
import Waba from "../../dao/Waba";
import { useLocation } from "react-router";
import qs from "qs";

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false },
  { id: "id", label: "ID", alignRight: false },
  { id: "name", label: "Template Name", alignRight: false, sortable: true },
  { id: "category", label: "Category", alignRight: false, sortable: true },
  { id: "status", label: "Status", alignRight: false, sortable: true },
  { id: "quality", label: "Quality", alignRight: false },
  { id: "language", label: "Language", alignRight: false },
  { id: "menu", label: "Action", alignRight: true },
];

export default function TemplateList() {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let idParam = queryParams.waba_id;

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("language");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [messageTemplates, setMessageTemplates] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [limit, setLimit] = useState(10);
  // const [paginate, setPaginate] = useState({});
  // const [before, setBefore] = useState("");
  // const [after, setAfter] = useState("");

  const [wabaOptions, setWabaOptions] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);

  const onDelete = async (name) => {
    try {
      let confirmResult = await swal.fire({
        title: "Confirmation",
        text: "Are you sure you want to delete " + name,
        icon: "info",
        confirmButtonText: "Yes",
        showCancelButton: true,
      });
      if (confirmResult.isConfirmed) {
        await MessageTemplate.delete_(name, selectedWabaId);
        // let result = await MessageTemplate.delete_(name, selectedWabaId);
        // console.log(result);
        getTemplates();
      }
    } catch (e) {
      // nothing
    }
  };

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log("MW", result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      if (formatted.length > 0) {
        let wabaFromParam = formatted.find((obj) => obj.value === idParam);

        if (wabaFromParam && idParam) {
          setSelectedWabaId(wabaFromParam.value);
          setSelectedWabaLabel(wabaFromParam.label);
        } else {
          setSelectedWabaId(formatted[0].value);
          setSelectedWabaLabel(formatted[0].label);
        }
      }

      setWabaOptions(formatted);
    } catch (e) {
      // nothing
    }
  };

  const getTemplates = async () => {
    setIsDataFetched(false);

    navigate("?waba_id=" + selectedWabaId);

    try {
      // let key = await PhoneNumber.getToken({ number: fetchNumId });
      let result = await MessageTemplate.getAll({
        waba_id: selectedWabaId,
        limit: limit,
      });
      // console.log(result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));
      setMessageTemplates(result.data);
      // setPaginate(result.paging);
      setIsDataFetched(true);
    } catch (e) {
      setIsDataFetched(true);
      console.log(e);
      // nothing
    }
  };

  useEffect(() => {
    getWabas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log("UE", selectedWabaId);
    if (selectedWabaId !== null) {
      getTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId, limit]);

  let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    count = page * rowsPerPage + 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - messageTemplates.length)
      : 0;
  const filteredData = applySortFilter(
    messageTemplates,
    getComparator(order, orderBy),
    filterName,
    "name"
  );
  const notFound = filteredData.length === 0;

  function TablePaginationActions(props) {
    // const theme = useTheme();
    const { page, onPageChange } = props;

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleBackButtonClick}
          // disabled={page === 0}
          aria-label="previous page"
        >
          <Typography>Back</Typography>
          {/* <NavigateBeforeIcon /> */}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          // disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <Typography>Next</Typography>
          {/* <NavigateNextIcon /> */}
        </IconButton>
      </Box>
    );
  }

  return (
    <Page title="Message Templates">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Message Templates
          </Typography>
          <Stack direction="row" spacing={3}>
            {/*<Button*/}
            {/*  variant="outlined"*/}
            {/*  component={RouterLink}*/}
            {/*  to="#"*/}
            {/*  startIcon={<Iconify icon="akar-icons:gear"/>}*/}
            {/*>*/}
            {/*  Namespace*/}
            {/*</Button>*/}
            <Button
              variant="contained"
              component={RouterLink}
              to={"/template/create/" + selectedWabaId}
              startIcon={<Iconify icon="akar-icons:plus" />}
            >
              New Message Template
            </Button>
          </Stack>
        </Stack>

        <Stack
          style={{
            marginBottom: 20,
          }}
          direction="column"
        >
          <small>Filter by Waba ID :</small>
          <div style={{ width: 300 }}>
            <Select
              onChange={(option) => {
                setSelectedWabaId(option.value);
                setSelectedWabaLabel(option.label);
              }}
              value={{
                label: selectedWabaLabel,
                value: selectedWabaId,
              }}
              options={wabaOptions}
            />
          </div>
        </Stack>

        {wabaOptions.length > 0 && (
          <Card>
            <SearchToolbar
              filterName={filterName}
              onFilterName={handleFilterByName}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table style={{ backgroundColor: "white", color: "white" }}>
                  <SortableTableHeader
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, key) => {
                        const {
                          id,
                          name,
                          category,
                          status,
                          quality,
                          language,
                        } = row;

                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                          >
                            <TableCell align="left">{count++}</TableCell>
                            <TableCell align="left">{id}</TableCell>
                            <TableCell align="left">{name}</TableCell>
                            <TableCell align="left">{category}</TableCell>
                            <TableCell align="left">
                              <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                              >
                                <Iconify
                                  icon="akar-icons:circle-fill"
                                  height={10}
                                  sx={{
                                    color:
                                      status === "APPROVED"
                                        ? "#57d95a"
                                        : "#d95757",
                                  }}
                                />
                                <Typography variant="p">{status}</Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">{quality}</TableCell>
                            <TableCell align="left">{language}</TableCell>
                            <TableCell align="right">
                              <Button
                                onClick={() => {
                                  navigate(
                                    `/template/manage/${selectedWabaId}/${id}`,
                                    { state: { templateData: row } }
                                  );
                                }}
                                variant={"outlined"}
                                style={{ textDecoration: "none" }}
                              >
                                Detail
                              </Button>
                              &nbsp;
                              <Button
                                onClick={() => {
                                  onDelete(name);
                                }}
                                variant={"outlined"}
                                style={{ textDecoration: "none" }}
                              >
                                Delete
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 69 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                  {(notFound || !isDataFetched) && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          {!isDataFetched ? (
                            <CircularProgress />
                          ) : (
                            <>Data is not found</>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={messageTemplates.length}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelDisplayedRows={() => <></>}
              ActionsComponent={TablePaginationActions}
              // nextIconButtonProps={}
            />
          </Card>
        )}
      </Container>
    </Page>
  );
}
